import { render, staticRenderFns } from "./StockCustomer.vue?vue&type=template&id=692c75a5&scoped=true&"
import script from "./StockCustomer.vue?vue&type=script&lang=js&"
export * from "./StockCustomer.vue?vue&type=script&lang=js&"
import style0 from "./StockCustomer.vue?vue&type=style&index=0&id=692c75a5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "692c75a5",
  null
  
)

export default component.exports